import { replace, toUpper } from 'ramda';

export const capitalize = replace(/^./, toUpper as any);

export const titleize = (string: string) => string.split(' ').map(capitalize).join(' ');

export const startCase = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
